import * as React from 'react';
import { ProblemSegment } from './ProblemSegment';
import { SolutionSegment } from './SolutionSegment';
import { HeroContent } from './HeroContent';
import { HeroPageLayout } from '../common/HeroPageLayout';
import { WhatIsLonchSegment } from './WhatIsLonchSegment';

const HomepageLayout = () => (
  <HeroPageLayout
    id="home" activeMenu="home"
    renderHeroContent={(mobile) => <HeroContent mobile={mobile} />}
   >

    <WhatIsLonchSegment />

    <ProblemSegment />

    <SolutionSegment />   

  </HeroPageLayout>
)

export default HomepageLayout



// WEBPACK FOOTER //
// ./src/home/HomepageLayout.tsx